import React from 'react';
import { useTheme } from '../../../contexts/ThemeContext';
import {
	compareModalSearchResultAvatarClassName,
	searchResultAvatarClassName
} from '../../../utils/avatarClassNames';
import getPlayerSearchSubtitle from '../../../utils/getPlayerSearchSubtitle';

const PlayerSearchBarResultsList = ({
	players,
	handlePlayerClick,
	containerClassName,
	containerStyle,
	isCompareModal
}) => {
	const { isDarkMode } = useTheme();

	const avatarClassName =
		isCompareModal && isDarkMode
			? compareModalSearchResultAvatarClassName
			: searchResultAvatarClassName;

	if (players.length === 0) return null;

	return (
		<div
			className={
				containerClassName ||
				'absolute bg-white dark:bg-dark-card border border-gray-200 dark:border-dark-border mt-2 p-2 rounded-md shadow-lg z-30 max-h-64 overflow-y-auto'
			}
			style={containerStyle || { top: '50px', left: '30px' }}
		>
			<ul>
				{players.map((player) => {
					const subtitle = getPlayerSearchSubtitle(player);

					return (
						<li
							key={`${player.id}-${player.position}`}
							className="p-2 cursor-pointer flex items-center rounded-md text-gray-900 dark:text-dark-text hover:bg-gray-100 dark:hover:bg-dark-bg hover:text-gray-900 dark:hover:text-dark-text"
							onClick={() => handlePlayerClick(player)}
						>
							<div className="hidden sm:block shrink-0">
								<img
									className={avatarClassName}
									src={`${player.image_url}?w=50&h=50`}
									alt={`${player.first_name} ${player.last_name}`}
									style={{
										width: 50,
										height: 50,
										objectFit: 'cover'
									}}
								/>
							</div>
							<div className="min-w-0 flex-1 flex flex-col justify-center">
								<span className="hover:underline text-xs md:text-base truncate">
									{player.first_name} {player.last_name}
								</span>
								{subtitle && (
									<span className="text-[11px] md:text-xs text-gray-500 dark:text-gray-400 truncate">
										{subtitle}
									</span>
								)}
							</div>
						</li>
					);
				})}
			</ul>
		</div>
	);
};

export default PlayerSearchBarResultsList;
